<template>
  <v-dialog
    :value="active"
    max-width="600"
    @input="$emit('update:active', $event)">
    <v-card>
      <div class="grey lighten-3 _fs-20 _fs-sm-24 pa-4">
        ข้อกำหนดและเงื่อนไขการให้บริการ
      </div>

      <div class="pa-4">
        <ul>
          <li style="list-style: decimal;">
            การรับชำระเงิน
            <ul>
              <li style="list-style: disc">
                ทาง Sellsuki รับชำระเงินโดยการโอนเงินผ่านบัญชีธนาคาร, บัตรเครดิต/เดบิต และ QR Code
              </li>
              <li style="list-style: disc">
                กรณีลูกค้าต้องการยกเลิกการชำระเงิน (Void) ผ่านบัตรเครดิต/เดบิตหรือ QR Code
                และระยะเวลาคืนเงินภายใน 7 วันทำการ หรือขึ้นอยู่กับธนาคารผู้ออกบัตร
              </li>
              <li style="list-style: disc">
                กรณีลูกค้าต้องการเงินคืน (Refund) จากการชำระเงินผ่านบัตรเครดิต/เดบิต
                ลูกค้าจะถูกหักค่าธรรมเนียม 2% และระยะเวลาคืนเงินภายใน 15-30 วันทำการ
                หรือขึ้นอยู่กับธนาคารผู้ออกบัตร
              </li>
            </ul>
          </li>

          <li style="list-style: decimal;">
            Credit term
            <ul>
              <li style="list-style: disc;">
                ทาง Sellsuki ไม่มี Credit term หากไม่มีการชำระเงินเข้ามา
                จะไม่สามารถทำการเปิดให้บริการได้
              </li>
            </ul>
          </li>

          <li style="list-style: decimal;">
            การส่งเอกสาร
            <ul>
              <li style="list-style: disc;">
                ทาง Sellsuki มีนโยบายในการส่งเอกสารทาง Email เท่านั้น
              </li>
            </ul>
          </li>

          <li style="list-style: decimal;">
            หนังสือรับรองการหักภาษี ณ ที่จ่าย
            <ul>
              <li style="list-style: disc;">
                ทาง Sellsuki จะมีการขอหนังสือรับรองการหักภาษี ณ ที่จ่ายตัวจริงจากทางลูกค้า
              </li>
            </ul>
          </li>

          <li style="list-style: decimal;">
            ใบกำกับภาษี
            <ul>
              <li style="list-style: disc;">
                ทาง Sellsuki จะส่งเป็น E-Tax ผ่านทาง Email เท่านั้น
              </li>
            </ul>
          </li>

          <li style="list-style: decimal;">
            การเปิดให้บริการ
            <ul>
              <li style="list-style: disc;">
                ระบบจะดำเนินการเปิดแพ็กเกจภายใน 1 - 2 วันทำการ
              </li>
            </ul>
          </li>

          <li style="list-style: decimal;">
            ข้อกำหนดในการใช้งาน
            <ul>
              <li style="list-style: disc;">
                ขอสงวนสิทธิ์ในการคืนเงินสำหรับลูกค้าที่ใช้บัญชี LINE Official Account
                ที่ผิดต่อข้อบังคับของบริษัท LINE Corporation ในทุกกรณี<br>
                สามารถดูเพิ่มเติมได้ที่
                <a
                  href="http://terms.line.me/line_terms?lang=th"
                  target="_blank">
                  http://terms.line.me/line_terms
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="grey--text"
          text
          @click="$emit('cancel')">
          ปิด
        </v-btn>

        <v-btn
          color="primary"
          text
          @click="$emit('accept')">
          ยอมรับ
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OrderPrivacyPolicy',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
